import { useField, useFormikContext } from "formik";

import { RadioGroupField } from "components/form/fields";
import { Section } from "components/layout";

import { CountriesField } from "../components";
import { CountryInput } from "../components/CountryInput";
import { TEXTS } from "../constants";
import { PROVIDER_FIELDS } from "../fields";
import { ProviderForm, VariantForm } from "../types";

export function TiVoAppFormCountriesTab() {
  const {
    values: { mode },
  } = useFormikContext<VariantForm | ProviderForm>();
  const [, { value: worldwide }] = useField<string>(
    PROVIDER_FIELDS.COUNTRIES.WORLDWIDE.name
  );

  const worldwideFieldProps = {
    ...PROVIDER_FIELDS.COUNTRIES.WORLDWIDE,
    values:
      mode === "variant"
        ? PROVIDER_FIELDS.COUNTRIES.WORLDWIDE.values
        : (PROVIDER_FIELDS.COUNTRIES.WORLDWIDE.values || []).filter(
            (v) => v.value !== "unset"
          ),
  };

  return (
    <Section header={TEXTS.COUNTRIES.HEADER}>
      <RadioGroupField {...worldwideFieldProps} />
      {worldwide === "false" && (
        <>
          <CountryInput
            {...PROVIDER_FIELDS.COUNTRIES.COUNTRIES_INPUT}
            tooltip={TEXTS.COUNTRIES.TOOLTIP}
          />
          <CountriesField {...PROVIDER_FIELDS.COUNTRIES.SUPPORTED_COUNTRIES} />
        </>
      )}
    </Section>
  );
}
